<ng-container>

  <!-- Filter -->
  <ng-container *ngIf="isFilterable" [matColumnDef]="this.colActionIcon">
    <mat-form-field>
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="filter">
    </mat-form-field>
  </ng-container>

  <!-- Table -->
  <table mat-table
         [dataSource]="tableDataSource"
         multiTemplateDataRows
         matSort
         [ngClass]="{'table-condensed-header': hasCondensedHeader, 'table-tinted-header': hasTintedHeader}"
         (matSortChange)="sortTable($any($event))">

    <!--Expand icon column-->
    <ng-container *ngIf="hasChildDataRows" [matColumnDef]="colExpandIcon">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" [id]="colExpandIcon">

        <button mat-icon-button title="Expand" aria-label="Expand" *ngIf="isCollapsed" (click)="expandedElement = expandedElement === element ? null : element; isCollapsed = !isCollapsed">
          <mat-icon class="icon" aria-hidden="false">expand_more</mat-icon>
        </button>

        <button mat-icon-button title="Collapse" aria-label="Collapse" *ngIf="!isCollapsed" (click)="expandedElement = expandedElement === element ? null : element; isCollapsed = !isCollapsed">
          <mat-icon class="icon" aria-hidden="false">expand_less</mat-icon>
        </button>

      </td>
    </ng-container>

    <!-- action column -->
    <ng-container *ngIf="showColActionIcon" [matColumnDef]="colActionIcon">
      <th mat-header-cell *matHeaderCellDef>Action</th>
      <td mat-cell *matCellDef="let element" [id]="colActionIcon">

        <!--radio button-->
        <mat-radio-button *ngIf="hasRadio" color="primary" [value]="element.id">
        </mat-radio-button>

        <!--preview icon-->
        <button *ngIf="showIconPreview" mat-icon-button title="Preview" aria-label="Preview" (click)="emitPreviewAction(element)">
          <mat-icon class="material-icons-outlined icon">visibility</mat-icon>
        </button>

        <!--download icon-->
        <button *ngIf="showIconDownload" mat-icon-button title="Download" aria-label="Download" (click)="emitDownloadAction(element)">
          <mat-icon class="material-icons-outlined icon">file_download</mat-icon>
        </button>

        <!--delete icon-->
        <button *ngIf="showIconDelete" mat-icon-button title="Delete" aria-label="Delete" (click)="emitDeleteAction(element)">
          <mat-icon class="material-icons-outlined icon">delete</mat-icon>
        </button>

        <!--menu icon with a single action attached-->
        <button *ngIf="showIconMenuSingleAction" mat-icon-button title="More Actions" (click)="emitRowAction(element)">
          <mat-icon class="icon">{{colActionIcon}}</mat-icon>
        </button>

        <!--menu icon with multiple actions attached-->
        <button *ngIf="showIconMenuMultiActions" mat-icon-button title="More Actions" [matMenuTriggerFor]="menu" aria-label="More Actions">
          <mat-icon class="icon" aria-hidden="false">{{ colActionIcon }}</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <span>Edit</span>
          </button>
          <button mat-menu-item (click)="emitRowAction(element)">
            <span>Delete</span>
          </button>
        </mat-menu>

        <!--Edit icon-->
        <button *ngIf="showIconEdit" mat-icon-button title="Edit" aria-label="Edit">
          <mat-icon class="material-icons-outlined icon" (click)="displayRowItem($event)">edit</mat-icon>
        </button>

      </td>
    </ng-container>
    <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.name">

      <!-- if sortable column header -->
      <ng-container *ngIf="tableColumn.isSortable; else notSortable">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="tableColumn.name"
            [arrowPosition]="tableColumn.position === 'right' ? 'before' : 'after'">
          {{tableColumn.name}}
        </th>
      </ng-container>
      <!-- else not sortable -->
      <ng-template #notSortable>
        <th mat-header-cell *matHeaderCellDef [class.text-right]="tableColumn.position == 'right'">
          {{tableColumn.name}}
        </th>
      </ng-template>

      <!-- column data -->
      <td mat-cell *matCellDef="let element" [class.text-right]="tableColumn.position == 'right'">
        {{element | dataPropertyGetter: tableColumn.dataKey | dateFormatter: tableColumn.dataKey : tableColumn.format : timezone}}
      </td>
    </ng-container>

    <!-- expanded content column -->
    <ng-container *ngIf="hasChildDataRows" matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
        <div class="element-detail" *ngIf="element.concurrentAuths?.length" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <table mat-table>
            <!--Expand icon column: leave empty for child data rows -->
            <ng-container *ngIf="hasChildDataRows" [matColumnDef]="colExpandIcon">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" [id]="colExpandIcon"></td>
            </ng-container>

            <!-- action column -->
            <ng-container *ngIf="colActionIcon?.length" [matColumnDef]="colActionIcon">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" [id]="colActionIcon">

                <button *ngIf="showIconMenuSingleAction" mat-icon-button title="More Actions" (click)="emitRowAction(element)">
                  <mat-icon class="icon">{{colActionIcon}}</mat-icon>
                </button>

                <!--Edit icon-->
                <button *ngIf="showIconEdit" mat-icon-button title="Edit" aria-label="Edit">
                  <mat-icon class="material-icons-outlined icon" (click)="displayRowItem($event)">edit</mat-icon>
                </button>

              </td>
            </ng-container>
            <ng-container *ngFor="let childTableColumn of childTableColumns" [matColumnDef]="childTableColumn.name">

              <!-- if sortable column header -->
              <ng-container *ngIf="childTableColumn.isSortable; else notSortable">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="childTableColumn.name"
                    [arrowPosition]="childTableColumn.position === 'right' ? 'before' : 'after'">
                  {{childTableColumn.name}}
                </th>
              </ng-container>
              <!-- else not sortable -->
              <ng-template #notSortable>
                <th mat-header-cell *matHeaderCellDef [class.text-right]="childTableColumn.position == 'right'">
                  {{childTableColumn.name}}
                </th>
              </ng-template>

              <!-- column data -->
              <td mat-cell *matCellDef="let element" [class.text-right]="childTableColumn.position == 'right'">
                {{element}}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="childColumnsToDisplay" style="visibility: collapse"></tr>
            <tr mat-row *matRowDef="let row; columns: childColumnsToDisplay;"></tr>
          </table>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
        [class.element-row]="element.concurrentAuths?.length"
        [class.expanded-row]="expandedElement === element">
    </tr>
    <ng-container *ngIf="hasChildDataRows">
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </ng-container>
  </table>

  <!-- Pagination -->
  <div [hidden]="tableDataSource.data.length == 0">
    <mat-paginator *ngIf="isPageable"
      [length]="tableDataSource.data.length"
      [pageSizeOptions]="paginationSizes"
      [pageSize]="defaultPageSize"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</ng-container>
